import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAxios } from "../../../../utils/endpoints";

export interface TenantResponse {
  tenantName: string;
  webAppID: string;
}

interface TenantState {
  tenantName: string | null;
  webAppId: string | null;
  status: "idle" | "loading" | "ready" | "error";
}

const initialState: TenantState = {
  tenantName: null,
  webAppId: null,
  status: "idle",
};

export const fetchTenantInformation = createAsyncThunk<TenantResponse>(
  "tenantInformation/fetchTenantInformation",
  async () => {
    const response = await getAxios("/azure/tenant", "GET");
    return response.data;
  }
);

const tenantSlice = createSlice({
  name: "tenantInformation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTenantInformation.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchTenantInformation.fulfilled, (state, action) => {
        state.tenantName = action.payload.tenantName;
        state.webAppId = action.payload.webAppID;
        state.status = "ready";
      })
      .addCase(fetchTenantInformation.rejected, (state) => {
        state.status = "error";
      });
  },
});

export default tenantSlice.reducer;
